"use client"

import { useState, useEffect, useRef } from "react"
import Image from "next/image"
import { useRouter } from "next/navigation"
import VolumeUpIcon from '@mui/icons-material/VolumeUp'
import VolumeOffIcon from '@mui/icons-material/VolumeOff'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import PauseIcon from '@mui/icons-material/Pause'
import CloseIcon from '@mui/icons-material/Close'


export default function ProfessionalsSection() {
  const [selectedProfessional, setSelectedProfessional] = useState(null)
  const [isMobile, setIsMobile] = useState(false)
  const [isMuted, setIsMuted] = useState(false)
  const [isPlaying, setIsPlaying] = useState(true)
  const [showPlayButton, setShowPlayButton] = useState(false)
  const videoRef = useRef(null)
  const router = useRouter()

  // Function to detect if user is on mobile
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768)
    }

    // Check on mount
    checkIsMobile()

    // Add event listener for window resize
    window.addEventListener('resize', checkIsMobile)

    // Cleanup event listener on unmount
    return () => window.removeEventListener('resize', checkIsMobile)
  }, [])

  // Handle play button visibility on mobile
  useEffect(() => {
    if (isMobile && showPlayButton) {
      const timer = setTimeout(() => {
        setShowPlayButton(false)
      }, 3000) // Hide after 3 seconds on mobile

      return () => clearTimeout(timer)
    }
  }, [isMobile, showPlayButton])
  const leftArrow = () => {
    return (
      <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 6L0.999999 6" stroke="#083140" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M5.30762 1.69223L0.999925 5.99992L5.30762 10.3076" stroke="#083140" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

    )
  }
  const rightArrow = () => {
    return (
      <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 10H18" stroke="#083140" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M13.6924 14.3078L18.0001 10.0001L13.6924 5.69238" stroke="#083140" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>


    )
  }


  const professionals = [
    {
      id: 1,
      name: "Brandon",
      years: 8,
      image: "/static/images/cka_landing/CKA_BrandonChristy_09018.jpg",
      gif: "/static/gifs/Brandon.gif",
      //video: "https://www.youtube.com/watch?v=uRbvhR2huF4", // Replace with actual video URL
      mobileVideo: 'https://player.vimeo.com/progressive_redirect/playback/1119871458/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1800375848&signature=77e1ea90a6f57c923c9aa29bebfa6b81623c9146aff024d4cf2ec3534df6b44d',
      desktopVideo: 'https://player.vimeo.com/progressive_redirect/playback/1119871566/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1800375848&signature=20a8d2f4184db7bfd411337441bf2e4c3fc8db30d97bba82348ba87bdcb784e3',
      description: "Expert financial planning and wealth management services for high-net-worth individuals."
    },
    {
      id: 2,
      name: "Grace",
      years: 5,
      image: "/static/images/cka_landing/CKA_GraceMoore_09287.jpg",
      gif: "/static/gifs/Grace.gif",
      video: "https://www.youtube.com/watch?v=uRbvhR2huF4", // Replace with actual video URL
      mobileVideo: 'https://player.vimeo.com/progressive_redirect/playback/1119872601/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1800375848&signature=8e03942551c24f6a4d664c7a9d371c0299ef5ae02e48303b683f131858847722',
      desktopVideo: 'https://player.vimeo.com/progressive_redirect/playback/1119872660/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1800375848&signature=dcbefa43e15ca7904dfe8c9c6f3b11cf61e067aa526fbbd9520ed2c3abe1d22c',
      description: "Comprehensive financial planning for individuals and families at all life stages."
    },
    {
      id: 3,
      name: "Marc",
      years: 5,
      image: "/static/images/cka_landing/CKA_MarcHenderson_09219.jpg",
      gif: "/static/gifs/Marc.gif",
      //video: "https://www.youtube.com/watch?v=uRbvhR2huF4", // Replace with actual video URL
      mobileVideo: 'https://player.vimeo.com/progressive_redirect/playback/1119873443/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1800375848&signature=a2c015ab4042b9a94c1cf4f6e5a78d5e776bcf4c180c2afd97dffe6f00ab1250',
      desktopVideo: 'https://player.vimeo.com/progressive_redirect/playback/1119873546/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1800375848&signature=4b46731c0e45f80e4d557f8c5d5d847ecb9ea226ad60a22190236e48057c84a0',
      description: "Specialized investment strategies and portfolio management for optimal returns."
    },

    {
      id: 4,
      name: "Reed",
      years: 2,
      image: "/static/images/cka_landing/CKA_ReedCrosson_09184.jpg",
      gif: "/static/gifs/Reed.gif",
      //video: "https://www.youtube.com/watch?v=uRbvhR2huF4", // Replace with actual video URL
      mobileVideo: 'https://player.vimeo.com/progressive_redirect/playback/1119873832/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1800375848&signature=bf00720487a6b8d9fdc4288bbf7a45e8ff80031706e24b6afd9aa97ad5205d22',
      desktopVideo: 'https://player.vimeo.com/progressive_redirect/playback/1119873658/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1800375848&signature=95279c0a0e2291a00f196d5a65bfd4b558a5f2f887fde4f51171c1a0eb6468d3',

      description: "Holistic wealth management including estate planning and tax optimization."
    },
    {
      id: 5,
      name: "Jim",
      years: 20,
      image: "/static/images/cka_landing/CKA_JimWise_09137.jpg",
      gif: "/static/gifs/Jim.gif",
      //video: "https://www.youtube.com/watch?v=uRbvhR2huF4", // Replace with actual video URL
      mobileVideo: 'https://player.vimeo.com/progressive_redirect/playback/1119872864/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1800375848&signature=ffe7c3a21123e7f68835c8dad30dbe8d6d08a53b23e528b219fa2e2d1af872c4',
      desktopVideo: 'https://player.vimeo.com/progressive_redirect/playback/1119872908/rendition/1080p/file.mp4?loc=external&oauth2_token_id=1800375848&signature=e02afbd17fdd0cef8ad62d4c1c99982832f9dac0eef52ffdb537b8f370bde3b3',
      description: "Holistic wealth management including estate planning and tax optimization."
    },
  ]

  const handleCardClick = (professional) => {
    setSelectedProfessional(professional)
  }

  const handleCloseModal = () => {
    setSelectedProfessional(null)
  }

  const handlePrevious = () => {
    if (selectedProfessional) {
      const currentIndex = professionals.findIndex(p => p.id === selectedProfessional.id)
      const previousIndex = currentIndex === 0 ? professionals.length - 1 : currentIndex - 1
      setSelectedProfessional(professionals[previousIndex])
    }
  }

  const handleNext = () => {
    if (selectedProfessional) {
      const currentIndex = professionals.findIndex(p => p.id === selectedProfessional.id)
      const nextIndex = currentIndex === professionals.length - 1 ? 0 : currentIndex + 1
      setSelectedProfessional(professionals[nextIndex])
    }
  }

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted
      setIsMuted(videoRef.current.muted)
    }
  }

  const togglePlayPause = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play()
        setIsPlaying(true)
      } else {
        videoRef.current.pause()
        setIsPlaying(false)
      }
    }
    // Hide play button after interaction on mobile
    if (isMobile) {
      setTimeout(() => setShowPlayButton(false), 2000)
    }
  }

  return (
    <section className="px-4 md:px-8  bg-[#F4FAFC] -mb-12 md:-mb-16 pb-20   ">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center pt-12"
        >
          <div className="text-2xl md:text-4xl font-medium font-['Lora'] text-blue-950  mb-12"
          >
            Discover the CKA<sup style={{ fontSize: '20px',}}>®</sup> Difference
          </div>
        </div>

        {/* Professional Photos Grid */}
        <div className="flex flex-col md:flex-row gap-4 md:gap-5 mb-12 md:mb-16">
          {professionals.map((professional, index) => (
            <div
              key={professional.id}
              className="group flex-1 flex flex-col justify-start items-start gap-5 cursor-pointer"
              onClick={() => handleCardClick(professional)}
            >
              {/* Main Image */}
              <div className={`w-full aspect-[4/5] md:aspect-[9/18] relative overflow-hidden rounded-xl transition-all duration-500 ease-out group-hover:scale-105 group-hover:shadow-2xl ${index % 2 === 0 ? 'group-hover:rotate-2' : 'group-hover:-rotate-2'
                }`}>
                <div className="absolute inset-0 rounded-xl overflow-hidden">
                  <Image
                    src={professional.image || "/placeholder.svg"}
                    alt={professional.name}
                    fill
                    className="object-cover transition-all duration-500 ease-out group-hover:scale-110"
                    sizes="(max-width: 768px) 50vw, 20vw"
                  />
                </div>

                {/* GIF Overlay on Hover */}
                {professional.gif && (
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out rounded-xl overflow-hidden">
                 
                    
                    <Image
                      src={professional.gif}
                      alt={`${professional.name} animation`}
                      fill
                      quality={100}
                      className="object-cover"
                      sizes="(max-width: 768px) 50vw, 20vw"
                    />
                    </div>
                
                )}
                
                {/* Overlay with play button */}
                <div 
                //play button
                className="absolute inset-0  opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-out rounded-xl">
                  <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
                    <div className="text-center  " style={{marginTop:'130px'}}>
                      <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                        <svg
                          className="w-6 h-6 ml-1"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Name and Details */}
              <div className="w-full pb-6 flex flex-col justify-start items-start gap-2">
                <div className="text-2xl font-semibold font-['Instrument-Sans'] text-gray-900">
                  {professional.name}
                </div>
                <div className="w-full flex flex-col justify-start items-start gap-2">
                  <div className="w-10 h-0.5 bg-orange-500" />
                  <div className="flex flex-row justify-between items-center w-full">
                    <div className="text-lg font-normal font-['Instrument-Sans'] text-blue-950/90">
                      {professional.years} years as a CKA<sup>®</sup>
                    </div>
                    <div className="flex md:hidden">
                      <div className="justify-start text-blue-950/90 text-base font-medium font-['Instrument-Sans'] underline leading-normal">Watch Now</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>


      </div>

      {/* Video Modal */}
      {selectedProfessional && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-[20px] w-full max-w-[897px] h-[80vh] md:h-[90vh] md:max-h-[592px] overflow-hidden flex flex-col">
            {/* Video Container - Takes up most of the space */}
            <div
              className="flex-1 relative bg-white md:max-h-[450px] group"
              onMouseEnter={() => setShowPlayButton(true)}
              onMouseLeave={() => setShowPlayButton(false)}
              onTouchStart={() => setShowPlayButton(true)}
            >
              <video
                ref={videoRef}
                // src={selectedProfessional.video}
                src={isMobile ? selectedProfessional.mobileVideo : selectedProfessional.desktopVideo}
                autoPlay
                loop
                muted={isMuted}
                playsInline
                className="w-full h-full object-cover aspect-[16/9] md:max-h-[450px]"
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
              />

              {/* Play/Pause Button - Centered */}
              {showPlayButton && (

                isPlaying ? (
                  <>
                    <div
                      className="absolute inset-0 flex items-center justify-center cursor-pointer"
                      onClick={togglePlayPause}
                    >
                      <div className="w-16 h-16 bg-transparent rounded-full flex items-center justify-center transition-colors">
                        <PlayArrowIcon className="text-transparent text-3xl ml-1 " />
                      </div>
                    </div>
                  </>

                ) : (
                  <div
                    className="absolute inset-0 flex items-center justify-center cursor-pointer"
                    onClick={togglePlayPause}
                  >
                    <div className="w-16 h-16 bg-black/50 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-black/70 transition-colors">
                      <PlayArrowIcon className="text-white text-3xl ml-1" />
                    </div>
                  </div>
                )

              )}

              {/* Control Buttons */}
              <div></div>
              <div
                //Volume Control
                className="absolute top-6 left-6 bg-stone-300 rounded-[40px] p-2 flex items-center gap-2.5 cursor-pointer hover:bg-stone-400 transition-colors"
                onClick={toggleMute}
              >
                {isMuted ? (
                  <VolumeOffIcon className="text-black text-lg" />
                ) : (
                  <VolumeUpIcon className="text-black text-lg" />
                )}
              </div>

              <div className="absolute top-6 right-6 bg-stone-300 rounded-[40px] p-2 flex items-center gap-2.5 cursor-pointer" onClick={handleCloseModal}>
                <div className="w-4 h-4 relative flex justify-center items-center">
                <CloseIcon className="text-black text-lg" />
                </div>
              </div>
            </div>

            {/* Modal Content - Flexed to bottom */}
            <div className="p-6 flex flex-col items-center gap-4 flex-shrink-0">
              {/* Name and Accent Line */}
              <div className="flex flex-col items-center gap-0.5">
                <div className="text-center text-[#192f5c] text-2xl font-semibold font-['Instrument-Sans']">
                  {selectedProfessional.name}
                </div>
                <div className="w-10 h-0 outline outline-2 outline-offset-[-1px] outline-[#fbb35c]" />
              </div>

              {/* Navigation Buttons */}
              <div className="w-full flex justify-between items-center">
                {/* Previous Button */}
                <div
                  role="button"
                  onClick={handlePrevious}
                  className="flex items-center gap-1.5 cursor-pointer hover:underline"
                >
                  <div className="w-5 h-5 px-0.5 py-[5px] flex flex-col justify-center items-center gap-2.5">
                    {leftArrow()}
                  </div>
                  <div className="text-black text-base font-medium font-['Instrument-Sans']">
                    Meet {professionals.find(p => p.id === (selectedProfessional.id === 1 ? professionals.length : selectedProfessional.id - 1))?.name}
                  </div>
                </div>

                {/* Next Button */}
                <div
                  role="button"
                  onClick={handleNext}
                  className="flex items-center gap-1.5 cursor-pointer hover:underline"
                >
                  <div className="text-black text-base font-medium font-['Instrument-Sans']">
                    Meet {professionals.find(p => p.id === (selectedProfessional.id === professionals.length ? 1 : selectedProfessional.id + 1))?.name}
                  </div>
                  <div className="w-5 h-5 px-0.5 py-[5px] flex flex-col justify-center items-center gap-2.5">
                    {rightArrow()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  )
}
